<template>
    <div>
        <OrderList-Header
            :list="status_count"
            :currId.sync="currStatus"
            :curId.sync="currReferer"
        >
        </OrderList-Header>
        <div>
            <DateFilter
                :currDate.sync="currDate"
                :dateRange.sync="dateRange"
                :vip.sync="vip"
                :searchType.sync="searchType"
                :handleClick="getOrderList"
            ></DateFilter>
        </div>
        <OrderList-Content
            v-loading="loading"
            :orderList="orderList"
            :getOrderList="getOrderList"
            :totalPage="totalPage"
            :currPage="currPage"
            :temp="temp"
            :isDetail="isDetail"
        ></OrderList-Content>
        <el-pagination
            background
            layout="prev, pager, next"
            :current-page="currPage"
            :page-count="totalPage"
            :getOrderList="getOrderList"
            @current-change="handlePageChange"
        >
        </el-pagination>
    </div>
</template>

<style lang="less" scoped>

</style>

<script>
    import OrderList from '../components/OrderList';
    import DateFilter from '../components/Common/DateFilter.vue';
    import Vue from 'vue';
    import { orderList } from '../stores/api';

    Vue.component('OrderList-Header', OrderList.Header);
    Vue.component('DateFilter', DateFilter);
    Vue.component('OrderList-Content', OrderList.Content);
    export default {
        data () {
            return {
                loading: false,
                orderList: [],
                status_count: [{name: '全部', num: '', status: 'all'},
                    {name: '待审核', num: '', status: 'payment'},
                    {name: '待发货', num: '', status: 'fahuo'},
                    {name: '已分配', num: '', status: 'yifenpei'},
                    {name: '已指派', num: '', status: 'yizhipai'},
                    {name: '已发货', num: '', status: 'yifahuo'},
                    {name: '已安装', num: '', status: 'yianzhuang'},
                ],
                currStatus: 'all',
                currReferer: '',
                currDate: '',
                dateRange: null,
                currPage: 1,
                totalPage: 1,
                keyword: '',
                vip: '',
                searchType: '',
                temp: '',
                isDetail: false,
                page: 1,
            };
        },
        beforeMount () {
            this.getOrderList();
        },
        activated() {
            this.getOrderList();
        },
        create() {
            // console.log()
        },
        methods: {
            getOrderList (pamars) {
                this.loading = true;
                let temp = {};
                    temp.session_id = localStorage.getItem('shouhou_session_id')
                    if (this.vip !== '') {
                        temp.searchkey = this.vip;
                    }

                    if (this.searchType !== '') {
                        temp.searchType = this.searchType;
                    }

                    if (this.currStatus !== '') {
                        temp.status = this.currStatus;
                    }
                    if (this.currReferer !== '') {
                        temp.referer = this.currReferer;
                    }
                    if (this.currDate !== '') {
                        temp.typetime = this.currDate;
                    } else if (this.dateRange) {
                        temp.starttime = Date.parse(this.dateRange[0]) / 1000;
                        temp.endtime = Date.parse(this.dateRange[1]) / 1000 + 24 * 60 * 60;
                    }
                    temp.page = this.page;
                this.temp = temp
                orderList(temp).then(res => {
                    console.log(res.data.data)
                    this.orderList = res.data.data;
                    this.orderList.forEach((item)=>{
                        if (item.goods_list){
                            item.goods_list.forEach((it)=>{
                                it['referer']=item.referer
                                it['order_id']=item.order_id
                                // it.push({referer:item.referer})
                            })
                        }
                    })
                    // this.status_count = res.data.status_count;
                    this.currPage = Number(res.data.page);
                    this.totalPage = Number(res.data.pagecount);
                    if (this.currStatus === '') {
                        this.currStatus = 'all';
                    }
                    if (this.currReferer === '') {
                        this.currReferer = ''
                    }
                    this.loading = false;
                });
            },
            handlePageChange(val) {
                this.page = val
                this.getOrderList();
            }
        },
        watch: {
            currStatus (val, old) {
                if (old !== '') {
                    this.getOrderList();
                }
            },
            currReferer (val, old) {
                // if (old !== '') {
                    this.getOrderList();
                // }
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/router/OrderList.vue